// Import Dependencies
import React from 'react';
// Import Local Styles
import styles from './modal.module.css';
import { CloseIcon } from '../SvgIcons';
import { MODAL_TYPES } from '~/common/consts';
import { useAppStore } from '~/common/store/appStore';
import { useShallow } from 'zustand/react/shallow';

type ModalProps = {
  onCloseCallBack?: any;
  children: JSX.Element;
  customStyles?: string;
};

export const TrialModal = (props: ModalProps) => {
  const { onCloseCallBack, children } = props;
  const { modifier } = useAppStore(useShallow((state) => ({ modifier: state.modifier })));

  function closeModal() {
    if (onCloseCallBack) onCloseCallBack();
  }

  return (
    <>
      <div
        className={styles.blocker}
        onClick={() => closeModal()}
        style={{
          backgroundImage:
            modifier === MODAL_TYPES.UNIFIED
              ? `url('https://www.lastpass.com/-/media/abe7220932c4494a9bd7d73722e73109.ashx')`
              : '',
        }}
      >
        <div
          className={`${styles.modal} ${styles[modifier === MODAL_TYPES.UNIFIED || modifier === MODAL_TYPES.UNIFIED_CHEVY_PREMIUM ? 'unified' : '']}`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className={styles['modal-wrap']}>{children}</div>
          <button onClick={() => closeModal()} className={styles.close}>
            <CloseIcon />
          </button>
        </div>
      </div>
    </>
  );
};
